const flutterProperty = {
  en: {
    flutterProperty: {
      title: 'Property',
      description: 'Problems with the flat or house',
      instructions: 'Instructions',
      'instructions.description':
        'Your Action Plan for obtaining insurance assistance.',
      'instructions.kz': 'Phone calls within Kazakhstan is free of charge',
      'instructions.whatsapp': 'Write to WhatsApp',
      'instructions.title': 'Instruction Property insurance',
      'acc1.title': 'Client Actions',
      'acc1.text1':
        '1. Please immediately notify the Insurance Company in writing no later than 3 days after discovery of the damage;',
      'acc1.text2':
        '2. Please immediately notify and document the incident with the competent authorities',
      'acc1.text3': 'in case of fire or explosion - the fire-fighting services',
      'acc1.text4': 'in case of natural disasters - the Rescue Board;',
      'acc1.text5': 'in case of flooding - the municipal services',
      'acc1.text6':
        'in case of theft/third-party crime - internal affairs authorities',
      'acc1.text7': 'other events - rescue service;',
      'acc1.text8': '3. Please take measures to rescue the insured property;',
      'acc2.title': 'List of documents',
      'acc2.text1': 'insurance contract;',
      'acc2.text2':
        'documents of competent authorities, determined by the legislation in force of the Republic of Kazakhstan, confirming the occurrence of the insured event and other documents related to the circumstances of the insured event, its causes, the scope of damage;',
      'acc2.text3':
        'documents on assessment of the amount of damage caused by an independent expert;',
      'acc2.text4':
        "copy of the Beneficiary's Identity card (for physical entities), copy of the registration certificate, the Beneficiary's Business Identification Number (BIN) (for legal entities);",
      'acc2.text5':
        'documents on the right of ownership (possession, use, disposal) of the damaged property.',
      'acc2.text6':
        "in case of insurance of pledged objects - a letter from the pledgor's bank stating the amount of liability and account number for payment transfer",
    },
  },
  kz: {
    flutterProperty: {
      title: 'Мүлік',
      description: 'Пәтермен немесе үймен байланысты проблемалар',
      instructions: 'Нұсқаулықтар',
      'instructions.description':
        'Сіздің сақтандыру көмегін алу үшін әрекет ету тәртібіңіз.',
      'instructions.kz': 'Қазақстан бойынша қоңырау шалу тегін',
      'instructions.whatsapp': 'WhatsApp-ға жазу',
      'instructions.title': 'Мүлікті сақтандыру нұсқаулығы',
      'acc1.title': 'Клиенттің әрекеттері',
      'acc1.text1':
        '1. Залал анықталған сәттен бастап шұғыл түрде, алайда 3 күннен кешіктірмей бұл туралы сақтандырушыға жазбаша хабарлау;',
      'acc1.text2':
        '2. болған оқиға туралы дереу хабарлау және оқиғаны құзыретті органдарда құжаттау',
      'acc1.text3': 'жарылыс/өрт кезінде - өрт сөндіру қызметі;',
      'acc1.text4': 'табиғи апаттар кезінде - құтқару қызметі;',
      'acc1.text5': 'су басқан кезде - ПИК;',
      'acc1.text6':
        'үшінші тұлғалардың ұрлық жасауы/құқыққа қайшы әрекеттері кезінде - ішкі істер органдары;',
      'acc1.text7': 'басқа оқиғалар - құтқару қызметі;',
      'acc1.text8':
        '3. сақтандырылған мүлікті құтқару жөнінде шаралар қабылдау;',
      'acc2.title': 'Құжаттар тізімі',
      'acc2.text1': 'сақтандыру шарты;',
      'acc2.text2':
        'Қазақстан Республикасының қолданыстағы заңнамасында айқындалған, сақтандыру жағдайының басталғанын растайтын құзыретті органдардың құжаттары және сақтандыру жағдайының мән-жайларына, оның себептеріне, залал мөлшеріне қатысты өзге де құжаттар;',
      'acc2.text3':
        'тәуелсіз сарапшы келтірген зиянның мөлшерін бағалау жөніндегі құжаттар;',
      'acc2.text4':
        'пайда алушының жеке куәлігінің көшірмесі (жеке тұлға үшін), тіркеу туралы куәліктің көшірмесі, пайда алушының БСН (заңды тұлға үшін);',
      'acc2.text5':
        'бүлінген мүлікке меншік құқығы (иелену, пайдалану, билік ету) туралы құжаттар.',
      'acc2.text6':
        'кепіл объектілерін сақтандыру кезінде-міндеттеме сомасын және төлемді аудару үшін шот нөмірін көрсете отырып, кепіл беруші банкінен хат',
    },
  },
  ru: {
    flutterProperty: {
      title: 'Имущество',
      description: 'Проблемы с квартирой или домом',
      instructions: 'Инструкции',
      'instructions.description':
        'Ваш порядок действий для получения страховой помощи',
      'instructions.kz': 'Звонок по Казахстану бесплатный',
      'instructions.whatsapp': 'Написать в WhatsApp',
      'instructions.title': 'Инструкция Страхование имущества',
      'acc1.title': 'Действия клиента',
      'acc1.text1':
        '1. Незамедлительно, но не позднее 3-х дней с момента обнаружения ущерба письменно известить об этом страховщика;',
      'acc1.text2':
        '2. немедленно сообщить о случившемся и документально зафиксировать происшествие в компетентных органах',
      'acc1.text3': 'при взрыве/пожаре – пожарная служба;',
      'acc1.text4': 'при стихийных бедствиях - служба спасения;',
      'acc1.text5': 'при затоплении - КСК;',
      'acc1.text6':
        'при краже /противоправных действиях третьих лиц - органы внутренних дел;',
      'acc1.text7': 'иные события - служба спасения;',
      'acc1.text8': '3. принять меры по спасению застрахованного имущества;',
      'acc2.title': 'Список документов',
      'acc2.text1': 'договор страхования;',
      'acc2.text2':
        'документы компетентных органов, определенных действующим законодательством Республики Казахстан, подтверждающие наступление страхового случая и иные документы, касающиеся обстоятельств страхового случая, его причин, размера ущерба;',
      'acc2.text3':
        'документы по оценке размера причиненного вреда, произведенной независимым экспертом;',
      'acc2.text4':
        'копию удостоверения личности, Выгодоприобретателя (для физического лица), копию свидетельства о регистрации, БИН Выгодоприобретателя (для юридического лица);',
      'acc2.text5':
        'документы о праве собственности (владения, пользования, распоряжения) на поврежденное имущество.',
      'acc2.text6':
        'при страховании объектов залога - письмо от банка залогодателя с указанием суммы обязательства и номера счета для перечисления выплаты',
    },
  },
};

export default flutterProperty;
